import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import e from "../../../../request.js";
import { throwIfAborted as t } from "../../../../core/promiseUtils.js";
import r from "../../tiling/TileKey.js";

var l = /*#__PURE__*/function () {
  function l(e) {
    _classCallCheck(this, l);

    this.url = e;
  }

  _createClass(l, [{
    key: "fetchTileIndex",
    value: function () {
      var _fetchTileIndex = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", (this._tileIndexPromise || (this._tileIndexPromise = e(this.url).then(function (e) {
                  return e.data.index;
                })), this._tileIndexPromise));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchTileIndex() {
        return _fetchTileIndex.apply(this, arguments);
      }

      return fetchTileIndex;
    }()
  }, {
    key: "dataKey",
    value: function () {
      var _dataKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e, r) {
        var _l;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.fetchTileIndex();

              case 2:
                _l = _context2.sent;
                return _context2.abrupt("return", (t(r), this._getIndexedDataKey(_l, e)));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function dataKey(_x, _x2) {
        return _dataKey.apply(this, arguments);
      }

      return dataKey;
    }()
  }, {
    key: "_getIndexedDataKey",
    value: function _getIndexedDataKey(e, t) {
      var _l2 = [t];
      if (t.level < 0 || t.row < 0 || t.col < 0 || t.row >> t.level > 0 || t.col >> t.level > 0) return null;
      var i = t;

      for (; 0 !== i.level;) {
        i = new r(i.level - 1, i.row >> 1, i.col >> 1, i.world), _l2.push(i);
      }

      var o,
          s,
          n = e,
          a = _l2.pop();

      if (1 === n) return a;

      for (; _l2.length;) {
        if (o = _l2.pop(), s = (1 & o.col) + ((1 & o.row) << 1), n) {
          if (0 === n[s]) {
            a = null;
            break;
          }

          if (1 === n[s]) {
            a = o;
            break;
          }

          a = o, n = n[s];
        }
      }

      return a;
    }
  }]);

  return l;
}();

export { l as default };